/* RESPONSIBLE TEAM: team-proactive-support */
import type Node from './node';
import type Edge from './edge';
import type Graph from './graph';

export abstract class ActionPerformed {
  graph!: Graph;

  constructor() {}

  abstract undo(): void;
  abstract redo(): void;
}

export abstract class NodeActionPerformed extends ActionPerformed {
  node!: Node;
  serializedNode?: any;

  constructor(node: Node) {
    super();
    this.node = node;
    this.graph = node?.graph;
  }
}

export abstract class EdgeActionPerformed extends ActionPerformed {
  edge!: Edge;
  serializedEdge: any;

  constructor(edge: Edge) {
    super();
    this.edge = edge;
    this.graph = edge?.graph;
  }
}

export class AddNode extends NodeActionPerformed {
  undo() {
    this.serializedNode = this.node.dataObject.serialize();
    this.graph.deleteNode(this.node);
  }

  redo() {
    this.graph.undeleteNode(this.node, this.serializedNode);
  }
}

export class DeleteNode extends NodeActionPerformed {
  constructor(node: Node) {
    super(node);
    this.serializedNode = node.dataObject.serialize();
  }

  undo() {
    this.graph.undeleteNode(this.node, this.serializedNode);
  }

  redo() {
    this.graph.deleteNode(this.node);
  }
}

export class MoveNode extends NodeActionPerformed {
  xDelta = 0;
  yDelta = 0;

  constructor(node: Node, xDelta: number, yDelta: number) {
    super(node);
    this.xDelta = xDelta;
    this.yDelta = yDelta;
  }

  undo() {
    this.node.position.x -= this.xDelta;
    this.node.position.y -= this.yDelta;
    this.graph.hooks.didUpdateNode(this.node);
    this.node.calculateBounds();
  }

  redo() {
    this.node.position.x += this.xDelta;
    this.node.position.y += this.yDelta;
    this.graph.hooks.didUpdateNode(this.node);
    this.node.calculateBounds();
  }
}

export class AddEdge extends EdgeActionPerformed {
  undo() {
    this.serializedEdge = this.edge.dataObject.serialize();
    this.graph.deleteEdge(this.edge);
  }

  redo() {
    this.graph.undeleteEdge(this.edge, this.serializedEdge);
  }
}

export class DeleteEdge extends EdgeActionPerformed {
  constructor(edge: Edge) {
    super(edge);
    this.serializedEdge = edge.dataObject.serialize();
  }

  undo() {
    this.graph.undeleteEdge(this.edge, this.serializedEdge);
  }

  redo() {
    this.graph.deleteEdge(this.edge);
  }
}
